function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2",
  transform: "translate(-476 -4801)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 33",
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(476 4801)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-keyboard-arrow-down",
  d: "M487.443 4822.885l6.87-6.885-6.87-6.885 2.115-2.115 9 9-9 9z",
  fill: "#f9cec8"
}));
var SvgOrangeArrow = function SvgOrangeArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
};
export default SvgOrangeArrow;